import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ColumnsService {

  // Used to transfer data between the general and advanced components
  private generalColumns = new BehaviorSubject<any>(null);
  private advancedColumns = new BehaviorSubject<any>(null);

  // Used to retrieve the column values on save
  private columns = new BehaviorSubject<any>(null);
  // Used to retrieve the spacing on save
  private spacing = new BehaviorSubject<any>(null);

  // Observable string streams
  generalColumns$ = this.generalColumns.asObservable();
  advancedColumns$ = this.advancedColumns.asObservable();

  // Service message commands
  modifyGeneralColumns(columns) { 
    this.generalColumns.next(columns);
    this.columns.next(columns);
  }

  modifyAdvancedColumns(columns) {
    const columnsToSave = [];
    columns.forEach(element => {
      const elementToSave = {...element};
      delete elementToSave.active;
      delete elementToSave.sizes;
      columnsToSave.push(elementToSave);
    });
      this.advancedColumns.next(columnsToSave);
      this.columns.next(columnsToSave); 
  }

  modifySpacing(spacing) {
    this.spacing.next(spacing);
  }

  getColumnsValue() {
    return {columns: this.columns.getValue(), spacing: this.spacing.getValue() };
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/services/columns-service.ts